import React from "react";

const FolderFill = () => (
	<g>
		<path d='M12.4142 5H21C21.5523 5 22 5.44772 22 6V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H10.4142L12.4142 5Z'></path>
	</g>
);

export default FolderFill;
